import React, { Component } from 'react';
import LoginContainer from '../components/LoginContainer';

class Login extends Component {

    render() {
        return <div>
            <LoginContainer />
        </div>;
    }
}

export default Login
